import { useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';

import {
  WorkloadDetailsContext,
  WorkloadEventsSection,
} from '@cast/split-me/features/cluster/workload-optimization';

import { buildInventoryWorkloadEventDetailsPath } from '../../navigation';

export const InventoryWorkloadEvents = () => {
  const { clusterId, workloadId: workloadIdParam } = useParams<{
    clusterId: string;
    workloadId: string;
  }>();
  const { workload } = useContext(WorkloadDetailsContext);
  const workloadId = workloadIdParam ?? workload?.id;

  const makeEventDetailsLink = useCallback(
    ({ eventId, createdAt }: { eventId: string; createdAt: string }) => {
      if (!clusterId || !workloadId) {
        return '';
      }

      return buildInventoryWorkloadEventDetailsPath({
        clusterId,
        workloadId,
        eventId,
        createdAt,
      });
    },
    [clusterId, workloadId]
  );

  return (
    <WorkloadEventsSection
      workloadId={workloadId}
      showSeeWorkloadEventsButton={false}
      makeEventDetailsLink={makeEventDetailsLink}
      disableUrlState
    />
  );
};
